import { LoaderCircle } from "lucide-react";
import { ReactNode } from "react";
import { motion } from "framer-motion";
import { animations } from "../lib/animations";

type Props = {
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  children: ReactNode;
  className?: string;
};

export default function PrimaryButton({
  onClick,
  loading,
  disabled,
  children,
  className,
}: Props) {
  return (
    <motion.button
      whileTap={!disabled && !loading ? animations.button.tap : undefined}
      whileHover={!disabled && !loading ? animations.button.hover : undefined}
      transition={animations.spring.medium}
      style={{
        background: "var(--button-primary-background)",
        padding: "var(--button-primary-padding)",
        borderRadius: "var(--button-primary-border-radius)",
        color: "var(--button-primary-foreground)",
      }}
      className={`h-10 w-full hover:opacity-90 transition-opacity flex items-center justify-center disabled:cursor-not-allowed disabled:opacity-70 ${className || ""}`}
      onClick={() => onClick()}
      disabled={loading || disabled}
    >
      {loading ? <LoaderCircle className="h-5 w-5 animate-spin" /> : children}
    </motion.button>
  );
}
